<login-container titel="Log ind med dit ID og kodeord" [technicianLogin]="true" [arbejder]="loginArbejder() || biometricLoginInProgress">
    @if (!skipVaerksliste) {
    <div class="vaerk-selector">
        <mat-form-field appearance="fill" class="vaerk-field" floatLabel="never">
            <input
                matInput
                id="tekniker-vaerk"
                name="tekniker-vaerk"
                [matAutocomplete]="vaerkAuto"
                [disabled]="loadingVaerker()"
                [(ngModel)]="vaerkSelection"
                (ngModelChange)="onVaerkSelectionChange($event)"
                placeholder="Vælg værk"
                aria-label="Vælg værk"
            />

            @if (vaerkSearch) {
            <button mat-icon-button matSuffix type="button" aria-label="Ryd værk" class="vaerk-clear" (click)="clearVaerkSearch()">
                <mat-icon>close</mat-icon>
            </button>
            }
        </mat-form-field>

        <mat-autocomplete
            #vaerkAuto="matAutocomplete"
            class="vaerk-autocomplete-panel"
            [displayWith]="displayVaerk"
            (optionSelected)="onVaerkOptionSelected($event.option.value)"
        >
            @for (option of filteredEforsyningOptions; track $index) {
            <mat-option [value]="option">{{ option.label }}</mat-option>
            }
        </mat-autocomplete>
        @if (loadingVaerker()) {
        <div class="vaerk-status">Henter værksliste...</div>
        } @if (loadingIndstillinger() || loadingPasswordFeatures()) {
        <div class="vaerk-status">Indlæser indstillinger...</div>
        } @if (vaerkFejlbesked) {
        <div class="vaerk-fejl">{{ vaerkFejlbesked }}</div>
        }
    </div>
    }
    <login-input
        #loginInput
        id="login-input"
        [parent]="form"
        [technicianLogin]="true"
        [technicianContactPhone]="technicianContactPhone"
        [loginDisabled]="!erKlarTilLogin"
        [teknikerPasswordFeaturesSupported]="teknikerPasswordFeaturesSupported"
        emailPlaceholder="Bruger-Id"
        passwordPlaceholder="Adgangskode"
        [showHelpLink]="false"
        helpLinkText="Har du brug for hjælp til login?"
        forgotPasswordText="Glemt adgangskode?"
        [showFirstTimeLink]="false"
        (loginSucceeded)="onLoginSucceeded()"
        (isLoading)="onLoginArbejderChange($event)"
    >
        <ng-template #biometricLoginButton>
            @if (isBiometricAvailable) {
            <button mat-raised-button color="secondary" type="button" (click)="biometricLogin()" [disabled]="!isBiometricAvailable">
                {{ biometricEnabled ? biometricActionText : "Aktiver biometrisk login" }}
            </button>
            }
        </ng-template>
    </login-input>
    <div login-footer class="login-contact" style="text-align: center">
        <a href="javascript:void(0);" (click)="loginHjaelpClick()" role="button" type="button">Har du glemt dine loginoplysninger?</a>
    </div>
</login-container>
